var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPainPointLowerBackPain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4645",
    "data-name": "Group 4645",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.023,
    height: 83.64,
    viewBox: "0 0 64.023 83.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4406",
    "data-name": "Rectangle 4406",
    width: 35.881,
    height: 20.771,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4407",
    "data-name": "Rectangle 4407",
    width: 32.98,
    height: 15.336,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4408",
    "data-name": "Rectangle 4408",
    width: 28.78,
    height: 10.26,
    fill: "#ff3131"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2876",
    "data-name": "Group 2876",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7015",
    "data-name": "Path 7015",
    d: "M173.2,396.083s4.123,15.112,7.518,26.575q1.54.113,3.109.114a42.262,42.262,0,0,0,4.933-.288l.8-19.436s-18.52-19.188-16.356-6.964",
    transform: "translate(-149.681 -339.131)",
    fill: "#221e3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7016",
    "data-name": "Path 7016",
    d: "M179.061,283.6l-5.2,10.789a28.335,28.335,0,0,0-.535,7.69,20.479,20.479,0,0,0,1.86,4.09c3.253,4.241,5.066,4.6,7.478,11.393,2.018,5.687,2.31,8.313,2.152,11.416A41.619,41.619,0,0,0,208.6,321c.752-3.694,1.4-7.752,1.913-12.435,1.3-11.869-1.829-17.7-1.829-17.7Z",
    transform: "translate(-149.89 -245.341)",
    fill: "#221e3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7017",
    "data-name": "Path 7017",
    d: "M151.773,29.514l.331-4.756-1.854-5.843-1.523-9.638a41.678,41.678,0,0,0-16.093-8.022c-2.688.334-6.44.5-9.148-.579a12.446,12.446,0,0,1-1.422-.662,41.641,41.641,0,0,0-17.578,4.054l-2.379,2.245,6.649,10.551,1.23-1.447,1.358,1.5,2.793,8.06,3.577,6.552.63,4.5L112.1,46.25s-.21,3.069,11.089,8.132c16.319,6.574,26.9-.824,26.9-.824l-2.734-11.773a27.375,27.375,0,0,1-.5-5.315l.138-2.2Z",
    transform: "translate(-88.335 -0.013)",
    fill: "#7cc2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7018",
    "data-name": "Path 7018",
    d: "M165.094,1.6c-2.514,14.637,6.976,21.808,13.425,23.909C188.614,28.8,196.9,15.761,197.7,11.362c.293-1.6-.215-3.809-.923-6.184A41.958,41.958,0,0,0,165.094,1.6",
    transform: "translate(-142.466 0)",
    fill: "#221e3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2868",
    "data-name": "Group 2868",
    transform: "translate(25.18 39.872)",
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2867",
    "data-name": "Group 2867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2866",
    "data-name": "Group 2866",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7019",
    "data-name": "Path 7019",
    d: "M189.805,296.361s5.59-1.509,10.453-.328a57.05,57.05,0,0,1,11.046,4.561,35.637,35.637,0,0,0,7.79,2.561c3.911.743,5.643,8.273-1.033,10.893-4.659,1.828-22.689,6.419-30.171-6.487-3.6-6.2,1.916-11.2,1.916-11.2",
    transform: "translate(-186.671 -295.581)",
    fill: "#ff5543",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2871",
    "data-name": "Group 2871",
    transform: "translate(26.125 40.651)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2870",
    "data-name": "Group 2870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2869",
    "data-name": "Group 2869",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7020",
    "data-name": "Path 7020",
    d: "M195.863,301.359s6.034,1.439,9.5,1.169c2.489-.194,11.6,5.084,11.6,5.084s7.966.523,9.339,3.544c1.486,3.272-2.111,2.368-5.02,3.65-4.14,1.825-17.512,4.75-25.8-4.88-4.289-4.983.377-8.568.377-8.568",
    transform: "translate(-193.672 -301.359)",
    fill: "#ff5543",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2874",
    "data-name": "Group 2874",
    transform: "translate(27.938 43.148)",
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2873",
    "data-name": "Group 2873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2872",
    "data-name": "Group 2872",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7021",
    "data-name": "Path 7021",
    d: "M209.148,319.881s6.179.054,7.9.283c2.379.317,8.467,3.377,8.467,3.377s3.068,1.745,5.214,1.839c8.181.359,5.377,2.926.3,4.225-4.851,1.242-18.47.7-22.939-6-2.7-4.052,1.055-3.726,1.055-3.726",
    transform: "translate(-207.114 -319.874)",
    fill: "#ff3131",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7022",
    "data-name": "Path 7022",
    d: "M312.082,271.048l-5.443-3.513c2.264.694,7.737-4.513,10.455-4.508l.7,4.285v3.82l-.4,5.068-.732,2.176H315.4l-.04-2.176-5.928,1.124-3.245.732-.962-1.97,3.568-4.252Z",
    transform: "translate(-264.052 -227.546)",
    fill: "#f49864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7023",
    "data-name": "Path 7023",
    d: "M315.715,164.262l1.026-6.55,6.327-14.061,8.818,4.544-6.952,14.058.082.238-4.665,3.715Z",
    transform: "translate(-273.128 -124.273)",
    fill: "#ffb080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7024",
    "data-name": "Path 7024",
    d: "M12.68,71.656l7.34-7.663L14.5,55.229,3.26,67.156,0,73.57,2.672,76.8s20.617,8.063,22.382,9.23l1.4,4.783,5.2,3.2,2.486-1.655-2.225-6.207s-4.923-4.895-6.37-5.466c-3.306-1.58-12.669-9.68-12.865-9.032",
    transform: "translate(0 -47.779)",
    fill: "#ef9373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7025",
    "data-name": "Path 7025",
    d: "M351.806,35.5l5.749,3.174,3.656,2.953-1.139,5.628-5.643,12.373-10.9-5.27,4.446-13.69Z",
    transform: "translate(-297.188 -30.709)",
    fill: "#7cc2e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4409",
    "data-name": "Rectangle 4409",
    width: 64.023,
    height: 83.64,
    fill: "none"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4410",
    "data-name": "Rectangle 4410",
    width: 64.023,
    height: 83.64,
    transform: "translate(0 0)",
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainPointLowerBackPain);
export default __webpack_public_path__ + "static/media/painPointLowerBackPain.664ff4a7a28283548be95e63dae1cae7.svg";
export { ForwardRef as ReactComponent };